// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"9394f13e","684":"45338bd2","703":"c046f3d8"}[chunkId] + ".chunk.js";
};